import { render, staticRenderFns } from "./ColorExtractor.vue?vue&type=template&id=5c8cceb8&scoped=true"
import script from "./ColorExtractor.vue?vue&type=script&lang=js"
export * from "./ColorExtractor.vue?vue&type=script&lang=js"
import style0 from "./ColorExtractor.vue?vue&type=style&index=0&id=5c8cceb8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c8cceb8",
  null
  
)

export default component.exports